import React from "react";
import { createBrowserRouter, useRouteError } from "react-router-dom";
import Home from "../pages/Home/index";
import About from "../pages/About/index";
import Works from "../pages/Works/index";
import Contact from "../pages/Contact/index";
import Layout from "../components/Layout";

const getBase = () => "/"; // www 専用運用のため常にルート

const ErrorPage = () => {
  const error = useRouteError() as Error;
  return (
    <div style={{ padding: "20px" }}>
      <h1>エラーが発生しました</h1>
      <p>ページが見つかりませんでした。</p>
      {error && (
        <details>
          <summary>エラー詳細</summary>
          <pre>{error.message || String(error)}</pre>
          {error.stack && <pre>{error.stack}</pre>}
        </details>
      )}
    </div>
  );
};

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Layout />,
      errorElement: <ErrorPage />,
      children: [
        { index: true, element: <Home /> },
        { path: "about", element: <About /> },
        { path: "works", element: <Works /> },
        { path: "contact", element: <Contact /> },
      ],
    },
  ],
  { basename: getBase() }
);

export default router;
